import axios from 'axios';
import store from '../store';
import notify from './notify';

export default function savePopulationData(itemType, axiosRoute, postData) {
    store.commit('overlay/toggle', true, { root: true });
    return new Promise((resolve, reject) => {
        axios.post(axiosRoute, postData)
            .then((response) => {
                const newItemId = response.data.data[itemType].id;
                notify(response.data.message, 'success');
                resolve(newItemId);
            })
            .catch((error) => {
                notify(error.response.data.message, 'error');
                store.commit('overlay/toggle', false, { root: true });
                reject(false);
            });
    });
}
